"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";

/**
 * Thin FullStory transport — sends pre-merged events and page properties to window.FS.
 * Swappable for a different analytics provider.
 */
export function useFullstory() {
  const $ = _c(1);
  const trackEvent = _temp;
  const setPageProperties = _temp2;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      trackEvent,
      setPageProperties
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2(pageName, properties_0) {
  if (typeof window !== "undefined") {
    const merged = {
      pageName,
      ...properties_0
    };
    try {
      if (localStorage.getItem("log-full-story-events") === "true") {
        console.info("[FullStory] setPageProperties", merged);
      }
    } catch {}
    if (window.FS) {
      window.FS("setProperties", {
        type: "page",
        properties: merged
      });
    }
  }
}
function _temp(name, properties) {
  if (typeof window !== "undefined") {
    try {
      if (localStorage.getItem("log-full-story-events") === "true") {
        console.info(`[FullStory] Event: ${name}`, properties);
      }
    } catch {}
    if (window.FS) {
      window.FS("trackEvent", {
        name,
        properties
      });
    }
  }
}